<template>
  <!-- The reading's one loading look (Chris, 2026-10-19): three small gold
       dots that breathe in turn. Used before the grounding line arrives and
       for "One moment…" after a name or an answer. Reduce motion: still dots. -->
  <span class="breath-dots" role="status" aria-live="polite">
    <span class="bd-dots" aria-hidden="true"><i></i><i></i><i></i></span>
    <span v-if="label" class="bd-label">{{ label }}</span>
    <span v-if="slow" class="bd-still-text">Still with you…</span>
    <span v-if="!label && !slow" class="bd-sr">Loading</span>
  </span>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

const props = defineProps({
  label: { type: String, default: '' },
  // After this many ms, add a quiet "Still with you…". 0 = never.
  stillAfter: { type: Number, default: 0 },
})
const slow = ref(false)
let timer = null
onMounted(() => {
  if (props.stillAfter > 0) timer = setTimeout(() => { slow.value = true }, props.stillAfter)
})
onBeforeUnmount(() => { if (timer) clearTimeout(timer) })
</script>

<style scoped>
.breath-dots {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-family: var(--cr-serif, Georgia, serif);
  font-style: italic;
  color: var(--cr-lavender, #c9b8f0);
}
.bd-dots { display: inline-flex; gap: 7px; align-items: center; }
.bd-dots i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #e9cf86;
  box-shadow: 0 0 6px rgba(233, 207, 134, 0.45);
  opacity: 0.35;
  animation: bd-breathe 1.8s ease-in-out infinite;
}
.bd-dots i:nth-child(2) { animation-delay: 0.3s; }
.bd-dots i:nth-child(3) { animation-delay: 0.6s; }
@keyframes bd-breathe {
  0%, 100% { opacity: 0.35; transform: scale(0.85); }
  40%      { opacity: 1;    transform: scale(1.1); }
}
.bd-still-text { opacity: 0.75; font-size: 0.92em; }
.bd-sr {
  position: absolute; width: 1px; height: 1px; overflow: hidden;
  clip: rect(0 0 0 0); white-space: nowrap;
}
@media (prefers-reduced-motion: reduce) {
  .bd-dots i { animation: none; opacity: 0.8; transform: none; }
}
</style>
